mainApp.directive('monitorItemsList', function() {
    return {
        templateUrl: '/public/directives/monitorItemsList.html',
        scope: {
            type: "=",
            pid: "=",
            stats: "=?",
            monitorItems: "=?",
            options: "=?",
            noupdate: "=?",
            interval: "=?",
            linkHealthEl: "@",
            currIndex: "=?",
            moveCursor: "&"
        },
        controller: ["$scope", "$interval", "$timeout", "$location", "$rootScope", "$filter", "$state", "LinksProcessingService", 'GeneralUtilsService', 'DateRangeService', function ($scope, $interval, $timeout, $location, $rootScope, $filter, $state, LinksProcessingService, GeneralUtilsService, DateRangeService) {
            $scope.queryId = 0;
            $scope.accountId = $state.params.accountId || "";
            var MIN_STATS_INTERVAL = 5000; // 5 seconds
            var DEFAULT_PAGE_SIZE = 10;
            var STATS_MIN_INTERVALS_COUNT = 100; // Ideal number of segments
            var destroy = false;

            $scope.innerSegmentsCount = 120;         // number of inner segments
            $scope.dateRange = DateRangeService.getNewRange();
            DateRangeService.initDateRange($scope.dateRange, false);
            $scope.monitorItems = {};
            $scope.currentAddress = null;
            $scope.sitesRealtimeData = {};
            $scope.statsInterval = 0;
            $scope.options = $scope.options || {};
            $scope.statsOnly = false;
            var ready = false;
            var dataReady = false;

            var COLORS_EXCEPTIONS = ["#fdd400", "#84b761", "#cc4748", "#448e4d", "#b93e3d"];

            var pageId = 'monitorlist' + $scope.type + new Date().getTime();
            if ($scope.pid) {
                pageId += 'single';
            }

            if($scope.type){
                if($scope.type === "sites"){
                    $scope.typeTitles = "Sites";
                }
                else if ($scope.type === "logins") {
                    $scope.typeTitles = "VPN Users";
                }
                else {
                    $scope.typeTitles = "Users";
                }
            }


            if ($scope.options) {
                $scope.$watch('options', function (newOptions, oldOptions) {
                    if (newOptions.updateData) {
                        $scope.dateRange.from = newOptions.minDate;
                        $scope.dateRange.to = newOptions.maxDate;

                        if($scope.type){
                            getData(true, true);
                        }
                        newOptions.updateData = false;
                    }
                }, true);
            }

            function init() {
                getData(true);
            }

           /* $scope.$watch('pid', function(){
                getData(true);
            });*/

            /*
             End of Init
             */

            function getData(fullUpdate, statsOnly) {
                if (destroy) {
                    return;
                }

                $scope.statsOnly = statsOnly;

                var options = {
                    accountId: $state.params.accountId,
                    fullUpdate: fullUpdate,
                    statsOnly: statsOnly,
                    pagination: $scope.pagination,
                    DEFAULT_PAGE_SIZE: DEFAULT_PAGE_SIZE,
                    searchVal: $scope.searchVal,
                    searchFields: $scope.type === "logins" ? ['email'] : null,
                    from: $scope.dateRange.from,
                    to: $scope.dateRange.to,
                    dateRange: $scope.dateRange,
                    MIN_STATS_INTERVAL: MIN_STATS_INTERVAL,
                    STATS_MIN_INTERVALS_COUNT: STATS_MIN_INTERVALS_COUNT,
                    scopeObject: $scope,
                    globalMin: $rootScope.dateRange.start,
                    globalMax: $rootScope.dateRange.end,
                    mergeDevices: true,
                    success: function (data) {
                        if (destroy) {
                            return;
                        }
                        $scope.loading = false;
                        $scope.$apply(function(){
                            if (fullUpdate && !statsOnly) {
                                $scope.monitorItems = {};
                                $scope.pagination.total = data.total;
                            }

                            var newItems;

                            if (statsOnly) {
                                //updateStats(data.items);
                                $scope.monitorItems = {};
                                newItems = LinksProcessingService.processItems(data.items, $scope.fromDate, $scope.toDate, 'CATO');
                                LinksProcessingService.mergeItems(newItems, statsOnly, $scope.monitorItems);
                                $scope.options.updated = true;
                            }
                            else {
                                newItems = LinksProcessingService.processItems(data.items, $scope.fromDate, $scope.toDate, 'CATO');
                                LinksProcessingService.mergeItems(newItems, statsOnly, $scope.monitorItems);
                                //$scope.monitorItems = newItems;
                                $scope.pagination.calculatePages();
                            }
                        });
                        DateRangeService.zoomTo($scope.dateRange.from.getTime(), $scope.dateRange.to.getTime(), $scope.dateRange.bucketDuration);
                    }
                };
                $timeout(function() {
                    $scope.loading = true;
                }, 0);

                LinksProcessingService.getData(options);
            }

            angular.element(document).ready(function(){
                if (destroy) {
                    return;
                }

                ready = true;
                if(dataReady){
                    $timeout(()=> {
                        drawCharts(true);
                    });
                }
            });

            $scope.itemsRenderFinished = function(){
                drawCharts($scope.statsOnly);
            };

            function updateStats(newItems) {
                for (var linkKey in $scope.monitorItems[$scope.pid].links) {
                    var currentLinkStats = $scope.monitorItems[$scope.pid].links[linkKey].rtStatsList;
                    if (newItems.length > 0) {
                        var currentNewItem = _.find(newItems, {'linkId': linkKey});

                        if (currentNewItem) {
                            currentNewItem.rtStatsList.forEach(function (stats) {
                                stats.usage = stats.throughputReceived + stats.throughputSent;
                                stats.packetLossUp = stats.packetLossUp * 100;
                                stats.packetLossDown = stats.packetLossDown * 100;
                            });
                            $scope.monitorItems[$scope.pid].links[linkKey].rtStatsList = currentNewItem.rtStatsList;
                        }
                        else {
                            currentLinkStats = [];
                            LinksProcessingService.insertRangeStats(currentLinkStats, $scope.fromDate, $scope.toDate);
                        }
                    }
                    else {
                        currentLinkStats = [];
                        LinksProcessingService.insertRangeStats(currentLinkStats, $scope.fromDate, $scope.toDate);
                    }
                }
            }

            function drawCharts(statsOnly) {
                for (var key in $scope.monitorItems) {
                    var currentMonitorItem = $scope.monitorItems[key];
                    if (statsOnly && currentMonitorItem.trafficChart) {
                        currentMonitorItem.trafficChart.clear();
                        currentMonitorItem.trafficChart = null;
                    }

                    var throughputData;

                    if (currentMonitorItem.trafficChart) {
                        throughputData = currentMonitorItem.trafficChart.dataProvider;
                    }
                    else {
                        throughputData = [];
                        currentMonitorItem.trafficChart = trafficChartDraw("traffic-chart-" + key, throughputData);
                    }

                    var linkWithStats = Object.entries(currentMonitorItem.links).filter(link => link[1].rtStatsList);
                    //sort links in descending order to have longest rtStatsList - otherwise we won't see any stats
                    linkWithStats.sort((l1, l2) => l2[1].rtStatsList.length - l1[1].rtStatsList.length);
                    for (var linkaIndex in linkWithStats) {
                        var linkKey = linkWithStats[linkaIndex][0]
                        var currentLink = linkWithStats[linkaIndex][1];
                        if (!currentMonitorItem.trafficChart.getGraphById(linkKey) && currentLink.rtStatsList) {
                            trafficChartAddGraph(currentMonitorItem.trafficChart, linkKey, linkKey + currentLink.internalIP);
                            currentLink.color = currentMonitorItem.trafficChart.graphs[currentMonitorItem.trafficChart.graphs.length - 1].lineColorR;
                            currentLink.legendBackgroundColor = GeneralUtilsService.convertHex(currentLink.color, 35);

                            if (throughputData.length === 0) {
                                currentLink.rtStatsList.forEach(function (item, index) {
                                    throughputData.push({
                                        sampleTime: item.sampleTime
                                    });
                                    throughputData[throughputData.length - 1]["usage" + linkKey] = item.usage;
                                });
                                // duplicating last item to show data until now
                                throughputData.push({
                                    sampleTime: currentLink.rtStatsList[currentLink.rtStatsList.length-1].sampleTimeEnd
                                });
                                throughputData[throughputData.length - 1]["usage" + linkKey] = currentLink.rtStatsList[currentLink.rtStatsList.length-1].usage;
                            }
                            else {
                                currentLink.rtStatsList.forEach(function (item, index) {
                                    var inserted;
                                    for (var i = 0; throughputData[i]; i++) {
                                        if (throughputData[i].sampleTime === item.sampleTime) {
                                            throughputData[i]["usage" + linkKey] = item.usage;
                                            inserted = true;
                                            break;
                                        }
                                        /* else if(throughputData[i].sampleTime > item.sampleTime){
                                         if(i == 0){
                                         throughputData.unshift({
                                         sampleTime: item.sampleTime
                                         });
                                         throughputData[0]["usage" + linkKey] = item.usage;
                                         inserted = true;
                                         break;
                                         }
                                         else{
                                         throughputData.splice(i-1, 0, {
                                         sampleTime: item.sampleTime
                                         });
                                         throughputData[i-1]["usage" + linkKey] = item.usage;
                                         inserted = true;
                                         break;
                                         }
                                         }*/
                                    }
                                });
                                // duplicating last item to show data until now
                                for (var i = 0; throughputData[i]; i++) {
                                    if (throughputData[i].sampleTime === currentLink.rtStatsList[currentLink.rtStatsList.length-1].sampleTimeEnd) {
                                        throughputData[i]["usage" + linkKey] = currentLink.rtStatsList[currentLink.rtStatsList.length-1].usage;
                                        break;
                                    }
                                }
                            }

                        }
                    }

                    trafficChartUpdate(currentMonitorItem.trafficChart, throughputData);
                }
                var $middleEl = $('.monitor-item-middle');

                $middleEl.on('click', '.monitor-traffic-chart', null, function (e) {
                    e.stopPropagation();
                });
                $middleEl.on('click', '.monitor-link-health', null, function (e) {
                    e.stopPropagation();
                });
            }

            $scope.showInlineSearch = function(){
                if(!$scope.showTitleSearch){
                    $scope.showTitleSearch = true;
                    $timeout(function() {
                        $('#titleSearch-' + ($scope.id ? $scope.id : $scope.$id)).focus();
                    });
                }
            };

            function checkInlineSearch(e){
                if(!$scope.searchVal || $scope.searchVal === ''){
                    if($(e.target).parents('.titlesearch').length === 0){
                        $scope.showTitleSearch = false;
                    }
                }
            }

            $('body').on('click', checkInlineSearch);

            $scope.$on('$destroy', function(){
                $('body').off('click', checkInlineSearch);
            });

            $scope.drillDown = function (item) {
                var type = item.site ? "site" : (item.login ? "login" : null);
                var monitoringFilter = {
                    pid: item.pid,
                    name: item[type].name,
                    type: type
                };

                var state;

                if(item.site){
                    state = "app.monitor";
                }
                else {
                    state = "app.monitor" + $filter('capitalize')(monitoringFilter.type);
                }

                $state.go(state, {
                    filter: angular.toJson(monitoringFilter)
                });

            };

            /*
             End Methods From View
             */

            /*
             Table Components
             */

            //todo merge with ngTable components
            $scope.pagination = {
                from: 0,
                pageSize: $scope.pageSize ? $scope.pageSize : DEFAULT_PAGE_SIZE,
                currentPage: 0,
                total: 0,
                pages: [],
                totalPages: 0,
                next: function () {
                    if (this.currentPage + 1 === this.totalPages) {
                        return;
                    }
                    this.currentPage++;
                    getData(true);
                },
                prev: function () {
                    if (this.currentPage === 0) {
                        return;
                    }
                    this.currentPage--;
                    getData(true);
                },
                goTo: function (page) {
                    if (this.currentPage != page) {
                        this.currentPage = page;
                        getData(true);
                    }
                },
                calculatePages: function () {
                    var i;
                    this.totalPages = Math.ceil(this.total / this.pageSize);
                    var pagesToshowInPaginator = Math.min(5, (this.totalPages - this.currentPage) + 2);
                    pagesToshowInPaginator = Math.min(pagesToshowInPaginator, this.totalPages);
                    this.pages = [];
                    if (this.currentPage <= 1) {
                        for (i = 0; i < pagesToshowInPaginator; i++) {
                            this.pages.push(i + 1);
                        }
                    }
                    else {
                        this.pages[0] = this.currentPage - 1;
                        for (i = 0; i < pagesToshowInPaginator - 1; i++) {
                            this.pages[i + 1] = this.currentPage + i;
                        }
                    }
                },
                getPageClass: function (page) {
                    var classStr = "";
                    if (page === (this.currentPage + 1)) {
                        classStr += " active ";
                    }

                    return classStr;
                }
            };

            $scope.$watch('searchVal', function (newValue, oldValue) {
                if (typeof newValue === 'undefined') {
                    return;
                }

                $scope.pagination.currentPage = 0;
                if ($scope.searchTimer) {
                    $timeout.cancel($scope.searchTimer);
                }
                $scope.searchTimer = $timeout(function () {
                    getData(true);
                    $scope.searchTimer = null;
                }, 300, false);
            });

            /*
             End Table Components
             */

            function trafficChartAddGraph(chart, linkKey, name) {
                var skippedColors = COLORS_EXCEPTIONS.concat();
                for(var graphKey in chart.graphs){
                    skippedColors.push(chart.graphs[graphKey].lineColor);
                }

                var counter = chart.graphs.length;
                var lineColor = chart.colors[counter];

                while (skippedColors.indexOf(lineColor) > -1) {
                    lineColor = chart.colors[++counter];
                }

                chart.addGraph({
                    "lineThickness": 3,
                    "dateFormat": "JJ:NN:SS DD, YYYY",
                    "fillAlphas": 0.4,
                    "title": name || linkKey,
                    lineColor: lineColor,
                    "fontSize": 4,
                    "id": linkKey,
                    "valueField": "usage" + linkKey,
                    connect: true,
                    balloonFunction: function (graphDataItem) {
                        return $filter('bits')(graphDataItem.values.value, 0) + "ps";
                    }
                });
            }

            function trafficChartUpdate(chart, data) {
                chart.dataProvider = data;
                chart.validateData();
            }

            function trafficChartDraw(target, data) {
                return AmCharts.makeChart(target, {
                    "type": "serial",
                    fontFamily: 'Roboto',
                    addClassNames: true,
                    "path": "/public/javascripts/external/amcharts/",
                    "pathToImages": "/public/javascripts/external/amcharts/images/",
                    "categoryField": "sampleTime",
                    theme: "new",
                    marginRight: 0,
                    marginLeft: 70,
                    marginBottom: 20,
                    marginTop: 20,
                    autoMargins: false,
                    "categoryAxis": {
                        gridAlpha: 0.15,
                        "minPeriod": "2500fff",
                        minHorizontalGap: 75,
                        markPeriodChange: true,
                        "parseDates": true,
                        labelsEnabled: true,
                        labelOffset: 0,
                        position: "top",
                        dateFormats: [{period: 'fff', format: 'JJ:NN:SS'}, {period: 'ss', format: 'JJ:NN:SS'}, {
                            period: 'mm',
                            format: 'JJ:NN'
                        }, {period: 'hh', format: 'JJ:NN'}, {period: 'DD', format: 'MMM DD'}, {
                            period: 'WW',
                            format: 'MMM DD'
                        }, {period: 'MM', format: 'MMM'}, {period: 'YYYY', format: 'YYYY'}]

                    },
                    "chartCursor": {
                        categoryBalloonEnabled: false,
                        cursorPosition: "mouse",
                        selectWithoutZooming: true,
                        zoomable: false,
                        "categoryBalloonDateFormat": "JJ:NN:SS, MMM DD, YYYY"
                    },
                    "trendLines": [],
                    "graphs": [],
                    "guides": [],
                    "valueAxes": [
                        {
                            "id": "ValueAxis-1",
                            titleFontSize: 10,
                            labelsEnabled: true,
                            labelFunction: function (value) {
                                return $filter('bits')(value, 0) + 'ps';
                            }
                        }
                    ],
                    "allLabels": [],
                    "dataProvider": data,
                    listeners: [{
                        event: "init",
                        method: setAfterInit
                    }]
                });
            }

            function setAfterInit(chart){
                chart = chart.chart;

                chart.addListener("changed", function (event) {
                    var category = event.chart.dataProvider[event.index];
                    if(!category){
                        $timeout(function() {
                            $scope.balloon = null;
                        }, 0);
                    }
                });

                chart.chartCursor.addListener("moved", function (event) {
                    var category = event.chart.dataProvider[event.chart.categoryAxis.xToIndex(event.x)];
                    var $chartDiv = $(event.chart.containerDiv);
                   /* if(!category){
                        $timeout(function() {
                            $scope.balloon = null;
                        }, 0);
                        return;
                    }*/


                    var chartPosition = $chartDiv.position();


                    $scope.moveCursor(chartPosition.left + event.x + 70, chartPosition.top + 17,  $chartDiv.parent().parent().height() + 17, category);

                });

                chart.addListener("rollOutGraph", function(event){
                   $scope.balloon = null;
                });
            }

            $scope.moveCursor = function(x, y, height, category){
                var $cursor = $('#traffic-chart-cursor');

                $cursor.css({
                    top: y,
                    height: height,
                    left: x
                });

                $timeout(function(){
                    $scope.balloon = category;
                }, 0);
            };

            $scope.showAddress = function (item, event) {
                if (item.location) {
                    $scope.currentAddress = item.location.city + ", " + item.location.region + ", " + item.location.country_long;
                    var $target = $(event.currentTarget || event.target);
                    var position = $target.offset();
                    $('#address-popup').css({
                        left: position.left,
                        top: position.top - (60 - $target.height())
                    });
                }
            };

            $scope.hideAddress = function () {
                $scope.currentAddress = null;
            };

            $scope.legendClick = function (e, index, linkId) {
                e.stopPropagation();

                var $el = $(e.target);
                var chart = $scope.monitorItems[index].trafficChart;
                if(!chart){
                    console.log(AmCharts.charts);
                    chart = AmCharts.charts[0];
                }
                var graph = chart.getGraphById(linkId);
                if ($el.hasClass('off')) {
                    $el.removeClass('off');
                    chart.showGraph(graph);
                    $scope.monitorItems[index].links[linkId].displayOff = false;
                }
                else {
                    $el.addClass('off');
                    chart.hideGraph(graph);
                    $scope.monitorItems[index].links[linkId].displayOff = true;
                }
            };

            $scope.numOfLinks = function (links) {
                if (!links) return 0;
                return Object.keys(links).length;
            };

            $scope.$on('$destroy', function () {
                destroy = true;
            });

            if ($scope.type) {
                init();
            }
        }]
    }
});
